import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WhiteLabelService} from "../../../../services/white-label.service";

@Component({
  selector: 'app-report-geo-chart',
  templateUrl: './report-geo-chart.component.html',
  styleUrls: ['./report-geo-chart.component.scss']
})
export class ReportGeoChartComponent implements OnInit, OnChanges {

  chartOptions: any;

  @Input() data: any;

  constructor(public whitelabel: WhiteLabelService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    console.log(this.data);

    const categories = [];
    const values = [];

    for (const [key, value] of Object.entries(this.data)) {
      categories.push(key);
      values.push((value as number).toFixed(2));
    }

    console.log(values);

    this.chartOptions = {
      series: [
        {
          data: values
        }
      ],
      chart: {
        type: "bar",
        height: 280,
        toolbar: {
          show: false
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top" // top, center, bottom
          }
        }
      },
      fill: {
        type: "gradient",
        colors: [this.whitelabel.currentColor('tertiary_colour')],
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 1,
          gradientToColors: [this.whitelabel.currentColor('secondary_colour'), this.whitelabel.currentColor('tertiary_colour')],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      stroke: {
        lineCap: 'round',
        show: true,
        colors: [this.whitelabel.currentColor('primary_colour')],
        width: 0
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        formatter: function (val: any, opts: any) {
          return val + '%'
        },
        style: {
          colors: ['black']
        }
      },
      tooltip: {
        enabled: false,
        enabledOnSeries: false
      },
      yaxis: {
        forceNiceScale: false,
        show: false,
        min: 0,
        max: 100,
        labels: {
          formatter: (value: any) => value.toFixed(0) +'%',
        },
      },
      xaxis: {
        categories: categories
      }
    };

  }

}
